"use strict";

(function () {
  'use strict';

  angular.module('lr.User', []).factory('User', User);
  User.$inject = ['$http', '$q', '$window', '$rootScope', 'authEvents', 'api', 'authErrors', 'authNames', 'SupportedProviders', '$cookies', '$location'];
  /* @ngInject */

  function User($http, $q, $window, $rootScope, authEvents, api, authErrors, authNames, SupportedProviders, $cookies, $location) {
    var LiveRezUser = {};
    var OAuthLoginAttempts = {};
    var service = {
      login: login,
      oAuthLogin: oAuthLogin,
      authPointCentral: authPointCentral,
      tokenRefresh: tokenRefresh,
      getPointCentralToken: getPointCentralToken,
      getToken: getToken,
      isAuthenticated: isAuthenticated,
      clearSession: clearSession,
      logout: logout,
      isProviderSupported: isProviderSupported,
      getOAuthCookie: getOAuthCookie
    };
    return service; ////////////////

    /**
     *
     * @param provider
     * @returns {boolean}
     */

    function isProviderSupported(provider) {
      var token = getToken();

      if (token.RTMAllowedProviders >= SupportedProviders[provider]) {
        return true;
      }

      return false;
    }
    /**
     *
     * @param spec
     * @returns {promise}
     */


    function login(spec) {
      var deferred = $q.defer();
      $http.post(api.proxy + '/auth/login', {
        username: spec.username,
        password: spec.password,
        securityID: spec.securityID
      }).then(function (data, status) {
        if (status === 200 || data.status === 200) {
          deferred.resolve(data);
        } else {
          deferred.reject(data);
        }
      }, function (data) {
        deferred.reject(data);
      });
      return deferred.promise;
    }
    /**
     *
     * @param spec
     * @returns {promise}
     */


    function oAuthLogin(oAuthToken) {
      if (!OAuthLoginAttempts.hasOwnProperty(oAuthToken)) {
        OAuthLoginAttempts[oAuthToken] = 1;
      } else {
        OAuthLoginAttempts[oAuthToken] = OAuthLoginAttempts[oAuthToken] + 1;
      }

      if (OAuthLoginAttempts[oAuthToken] > 2) {
        console.log('Exited with Too many login requests');
        return $q.reject('Too many login requests');
      }

      var deferred = $q.defer();
      $http.post(api.proxy + '/auth/oauth', {}).then(function (data, status) {
        if (status === 200 || data.status === 200) {
          deferred.resolve(data);
        } else {
          deferred.reject(data);
        }
      }, function (data) {
        deferred.reject(data);
      });
      return deferred.promise;
    }
    /**
     *
     * @param adminCustDataID
     * @returns {promise}
     */


    function authPointCentral() {
      var deferred = $q.defer(); //if (User.isAuthenticated()) {

      var token = getToken();

      if (token) {
        var adminCustDataID = getToken().AdminCustDataID;
      } else {
        return deferred.reject();
      }

      $http.post(api.proxy + '/PointCentral/Manager/Login/' + adminCustDataID, {}).then(function (data) {
        deferred.resolve(data);
      }, function (data) {
        deferred.reject(data);
      }); //} else {
      //  deferred.reject(authErrors.notAuthenticated);
      //}

      return deferred.promise;
    }
    /**
     *
     * @returns {*}
     */


    function tokenRefresh() {
      var deferred = $q.defer();
      var token = getPointCentralToken().seamlessLoginToken;
      $http.post(api.proxy + '/PointCentral//Manager/ResetToken', {
        token: token
      }).success(function (data) {
        deferred.resolve(data);
      }).error(function (data) {
        deferred.reject(data);
      });
      return deferred.promise;
    }
    /**
     *
     * @returns {*}
     */


    function getPointCentralToken() {
      if (LiveRezUser.pointCentral) {
        return LiveRezUser.pointCentral;
      } else {
        LiveRezUser.pointCentral = JSON.parse($window.sessionStorage.point);
        return LiveRezUser.pointCentral;
      }
    }
    /**
     *
     * @param str
     * @returns {string}
     */


    function urlBase64Decode(str) {
      var output = str.replace('-', '+').replace('_', '/');

      switch (output.length % 4) {
        case 0:
          break;

        case 2:
          output += '==';
          break;

        case 3:
          output += '=';
          break;

        default:
          throw 'Illegal base64url string!';
      }

      return window.atob(output);
    }
    /**
     *
     * @returns {{}}
     */


    function getClaimsFromToken() {
      try {
        var token = $window.sessionStorage.token;
        var user = {};

        if (typeof token !== 'undefined') {
          var encoded = token.split('.')[1];
          user = JSON.parse(urlBase64Decode(encoded));
        }

        return user;
      } catch (e) {
        console.log(e);
        clearSession();
        $rootScope.$broadcast(authEvents.login, true);
        return null;
      }
    }
    /**
     *
     * @returns {*}
     */


    function getToken() {
      if (!isAuthenticated()) {
        return;
      } //cache the token after we get it once


      if (LiveRezUser.token) {
        return LiveRezUser.token;
      } else {
        LiveRezUser.token = getClaimsFromToken();
        return LiveRezUser.token;
      }
    }
    /**
     *
     * @returns {*}
     */


    function getOAuthCookie() {
      var _cookie = $cookies.get(authNames.cookie);

      var cookieData;

      if (_cookie) {
        try {
          cookieData = JSON.parse(_cookie);
        } catch (ex) {
          console.log(ex);
        }
      }

      return cookieData;
    }
    /**
     *
     * @returns {boolean}
     */


    function isAuthenticated() {
      var token;

      if ($window.sessionStorage.token === undefined) {
        return false;
      } else {
        token = $window.sessionStorage.token;
        return !!token;
      }
    }
    /**
     *
     */


    function clearSession() {
      delete $window.sessionStorage.token;
      delete $window.sessionStorage.point;
      LiveRezUser.token = null;
      LiveRezUser.pointCentral = null;
    }
    /**
     *
     */


    function logout() {
      var callback = function callback() {
        clearSession();
        $rootScope.$broadcast(authEvents.login, true);
        window.location.reload();
      };

      $http.post(api.proxy + '/auth/logout', {}).then(function (response) {
        callback();
      }, function (error) {
        callback();
      });
    }
  }
})();